import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MentoringReportsModel } from 'common/models/page-models/reports/mentoring-reports/mentoring-data-model';
import { MentoringReportsListingModel } from 'common/models/page-models/reports/mentoring-reports/mentoring-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { MentoringReportsWidgetService } from 'common/widget/reports/mentoring-reports.widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class MentoringReportsResolver extends GridResolver<MentoringReportsModel, MentoringReportsListingModel> {
    constructor(
        protected fs: MentoringReportsWidgetService,
        protected override  router: Router,
        protected override  systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

     override modifyResponseData(dataModel: any, meta: any, widget: any) {
        dataModel['filterData'] = new MentoringReportsModel();
        return dataModel;
    }
}